import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import CentroCustoService from "service/administracao/cadastro/centrocusto/CentroCustoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const centroCustoService = new CentroCustoService();

export default function CentroCustoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Centro de custo');

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={centroCustoService} urlService="/centrocusto" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="centrocusto">
            <Column
                field="codigo" header="Código" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column
                field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
        </BaseListagem>
    )
}
